export const getExpirationDateFirstParcell = ({
  vencimentoParcelas,
  mesVencimentoPrimeiraParcela,
}) => {
  const date = new Date();
  const currentMonth = date.getMonth();

  const downpaymentMonthValue = mesVencimentoPrimeiraParcela?.id;
  const expirationDay = Number(vencimentoParcelas.split(' ')[2]);

  date.setMonth(currentMonth + downpaymentMonthValue);
  date.setDate(expirationDay);

  return date;
};
